<div class="ui container">
  <div class="ui grid">
    <div class="column">
      <h1>Stats</h1>
    </div>
  </div>
  <div *ngIf="fetching" class="ui basic very padded segment">
    <div class="ui inverted active centered inline huge text loader">
      Loading stats...
    </div>
  </div>
  <div class="section" *ngIf="!fetching">
    <h2>Overall stats</h2>
    <div class="ui inverted padded segment section">
      <div class="ui divided inverted grid">
        <div class="doubling six column row">
          <div class="column">
            <h5>Bounties created</h5>
            <p>
              <i class="i yellow target icon"></i>
              {{ bountiesCount }}
            </p>
          </div>
          <div class="column">
            <h5>Completed bounties</h5>
            <p>
              <i class="i orange trophy icon"></i>
              {{ bountiesPaidCount }}
            </p>
          </div>
          <div class="column">
            <h5>Total reward money claimed</h5>
            <p>
              <i class="i green money icon"></i>
              {{ totalPaid / 100 | currency}}
            </p>
          </div>
          <div class="column">
            <h5>Claims Submitted</h5>
            <p>
              <i class="teal circle outline icon"></i>
              {{ claimsCount }}
            </p>
          </div>
          <div class="column">
            <h5>Registered Users</h5>
            <p>
              <i class="purple user icon"></i>
              {{ usersCount }}
            </p>
          </div>
          <div class="column">
            <h5>Comments</h5>
            <p>
              <i class="envelope outline icon"></i>
              {{ commentsCount }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <h2>Top Bounty Hunters</h2>
    <table class="ui inverted table">
      <thead>
        <th>Rank</th>
        <th>Username</th>
        <th>Bounties won</th>
        <th>Total earned</th>
      </thead>
      <tbody>
        <tr *ngFor="let user of topPlayers; let index = index">
          <td>
            {{ index + 1 }}
          </td>
          <td>
            <app-user-label [user]="user"></app-user-label>
          </td>
          <td>
            {{ user.won_bounties }}
          </td>
          <td>
            <i class="small money bill green alternate icon"></i>
            {{ user.rewardsTotal / 100 | currency }}
          </td>
        </tr>
      </tbody>
    </table>
    <h2>Top Bounty Creators</h2>
    <table class="ui inverted table">
      <thead>
        <th>Rank</th>
        <th>Username</th>
        <th>Bounties paid</th>
        <th>Total paid</th>
      </thead>
      <tbody>
        <tr *ngFor="let user of topCreators; let index = index">
          <td>
            {{ index + 1 }}
          </td>
          <td>
            <app-user-label [user]="user"></app-user-label>
          </td>
          <td>
            {{ user.completed_bounties }}
          </td>
          <td>
            <i class="small money bill green alternate icon"></i>
            {{ user.totalPaid / 100 | currency }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
